function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classnames from 'classnames';
import { Dropdown, DropdownItem } from '../../index';
export const UserMenuItem = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(DropdownItem, props, children);
};
export const UserMenuFooter = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "user-menu__footer"
}, children);
export const UserMenuHeader = ({
  children,
  className = '',
  style = {}
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames(className, 'user-menu__header'),
  style: style
}, children);
export const UserMenu = ({
  children,
  ...other
}) => /*#__PURE__*/React.createElement(Dropdown, _extends({
  icon: "User",
  iconSize: 28,
  iconColor: "grey-800",
  menuPosition: "left"
}, other), children);